import styled from "styled-components"
import Img from "gatsby-image"
import { motion } from "framer-motion"
import Vimeo from '@u-wave/react-vimeo';
import { breakpoints } from "../../../utils/styles"

export const Section = styled.div`
  background: ${({ theme, color }) =>
    color ? color : theme.color.backgroundSectionOne};
`

export const Container = styled.div`
  display: flex;
  max-width: 1600px;
  padding: 96px 48px;
  margin: auto;

  @media (max-width: ${breakpoints.l}px) {
    flex-direction: column;
    padding: 48px 24px;
  }
`

export const Column = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
`

export const VideoElement = styled(motion.div)`
  position: relative;
  cursor: pointer;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadow.card};
`

export const PlayIcon = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 64px;
  height: 64px;
  z-index: 1;
  margin: auto;
`

export const Content = styled.div`
  color: ${({ theme, color }) => (color ? color : theme.color.black)};
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: ${breakpoints.l}px) {
    text-align: center;
  }
`

export const Image = styled(Img)`
  width: 500px;
  margin: auto;

  @media (max-width: ${breakpoints.xl}px) {
    width: 400px;
  }
`

export const Description = styled.p`
  font-size: 24px;
  line-height: 32px;

  @media (max-width: ${breakpoints.xl}px) {
    font-size: 16px;
    line-height: 24px;
  }
`

export const ModalContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  iframe {
    max-width: 1200px;
    width: 100%;
  }
`

export const VideoPlayer = styled(Vimeo)`
  max-width: 1200px;
  width: 100%;
`

export const ModalButton = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  padding: 16px;
  margin: 16px;
  cursor: pointer;
  line-height: 12px;

  @media (max-width: ${breakpoints.xl}px) {
    margin: 8px;
  }

  img {
    margin: 0;
    width: 32px;
    height: 32px;

    @media (max-width: ${breakpoints.m}px) {
      width: 24px;
      height: 24px;
    }
  }
`
